import * as actions from './datatable/actions'
import * as getters from './datatable/getters'
import * as helpers from './datatable/helper'
import mutations from './datatable/mutations'
import {defaultFields} from '../data'

const state = () => {
	return {
		selectedFilters: [],
		showDetail: false,
		detail: null,
		totalEvent : null,
		poDetail : null,
		spmScoring : null,
		picDetail : null,
		fieldsToFilter: null,
		tableFields: defaultFields,
		keyword : '',
		vendorName : '',
		commodity : '',
		organization : [],
		city : '',
		province : '',
		error : null,
		loading : false,
		modalLoading : false,
		query : '',
		modalFetch : false,
		statusFetch : '',
		manualFilter : null
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
	helpers
}